module.exports = __webpack_public_path__ + "static/img/site-8.d0843d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-8.png
// module id = KYYT
// module chunks = 0